import qs from 'qs';
import { network } from 'services/network';

export const deleteTag = ({ tagId }) => {
    const querystring = qs.stringify({ tagId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/deleteTag${querystring}`;

    return network.post(url).then((response) => response.data);
};
